<div class="dialog-container">
  <div class="dialog-header">
    <h2>Editar Usuário</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>
  </div>

  <!--  {{usuarioForm.value | json}}-->
  <div class="dialog-content">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

    <form [formGroup]="usuarioForm">
      <div class="row g-2">
        <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Login</mat-label>
            <input matInput readonly formControlName="dscLogin" maxlength="50" required />
            <mat-error *ngIf="usuarioForm.get('dscLogin')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="dscNome" maxlength="100" required />
            <mat-error *ngIf="usuarioForm.get('dscNome')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email</mat-label>
            <input matInput formControlName="dscEmail" maxlength="100" required />
            <mat-error *ngIf="usuarioForm.get('dscEmail')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('dscEmail')?.hasError('dscEmail')">E-mail inválido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>DDD</mat-label>
            <input matInput formControlName="numDddFone" maxlength="2" />
            <mat-error *ngIf="usuarioForm.get('numDddFone')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('numDddFone')?.hasError('pattern')">DDD inválido</mat-error>
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Telefone</mat-label>
            <input matInput formControlName="numFone" mask="00000-0000" placeholder="ex. 91234-5678" maxlength="9" />
            <mat-error *ngIf="usuarioForm.get('numFone')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('numFone')?.hasError('pattern')">Telefone inválido</mat-error>
          </mat-form-field>
        </div>
<!-- {{usuarioForm.value | json}}
{{perfis | json}} -->

      </div>
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Perfil</mat-label>
            <mat-select formControlName="codPerfil" [disabled]="true">
              <mat-option [value]="usuarioForm.get('codPerfil')?.value">{{usuarioForm.get('descPerfil')?.value}}</mat-option>
                <mat-option *ngFor="let perfil of perfis" [value]="perfil.codPerfil">{{perfil.dscPerfil}}
                </mat-option>
              </mat-select>
            <mat-error *ngIf="usuarioForm.get('codPerfil')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col d-flex justify-content-end gap-2">
          <button mat-flat-button type="submit" color="accent" (click)="onConfirmar()"
            [disabled]="usuarioForm.invalid || isUnchanged">
            <mat-icon>check</mat-icon> Confirmar
          </button>
          <button mat-flat-button type="button" (click)="onCancelar()">
            <mat-icon>close</mat-icon> Cancelar
          </button>
        </div>
      </div>
    </form>

  </div>
</div>